import { MARQUEE_WORDS, MANIFESTO, PRODUCE } from "@/data/studio";
import { Eyebrow, H2, Reveal } from "./ui";

export const StudioMarquee = () => {
  const row = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div data-testid="studio-marquee" className="overflow-hidden border-y border-white/10 bg-sink py-7">
      <div className="studio-marquee flex w-max items-center">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="studio-outline whitespace-nowrap px-8 font-display text-5xl font-extrabold uppercase sm:text-7xl">{w}</span>
            <span className="h-2.5 w-2.5 rounded-full bg-brand" />
          </span>
        ))}
      </div>
    </div>
  );
};

export const Manifesto = () => (
  <section data-testid="studio-manifesto" className="bg-sink py-24 sm:py-32 lg:py-40">
    <div className="mx-auto grid max-w-[1480px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-5">
        <Reveal><Eyebrow>The Difference</Eyebrow></Reveal>
        <Reveal delay={0.05}><H2 className="mt-6">20 Generated Clips <span className="text-brand">Don't Make a Video.</span></H2></Reveal>
        <Reveal delay={0.1} className="mt-8 max-w-md">
          <p className="text-lg text-zinc-200">Generative AI makes it possible to create enormous amounts of visual content.</p>
          <p className="mt-3 text-base text-zinc-400">But more output doesn't automatically mean better content.</p>
        </Reveal>
      </div>
      <div className="lg:col-span-6 lg:col-start-7">
        <ol className="border-t border-white/10" data-testid="studio-manifesto-list">
          {MANIFESTO.map((l, i) => (
            <Reveal as="li" key={l} delay={i * 0.04}>
              <div className="group flex items-baseline gap-6 border-b border-white/10 py-5 sm:py-6">
                <span className="font-mono text-[11px] text-brand">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-display text-xl font-medium text-zinc-400 transition-colors duration-500 group-hover:text-white sm:text-2xl">{l}</span>
              </div>
            </Reveal>
          ))}
        </ol>
        <Reveal className="mt-10">
          <p className="font-mono text-[12px] uppercase tracking-[0.3em] text-brand">That's what we produce.</p>
          <p className="mt-4 max-w-xl text-lg leading-relaxed text-zinc-200">Perfect Digitals takes generative AI beyond individual clips and turns it into complete, professionally produced video content.</p>
        </Reveal>
      </div>
    </div>
  </section>
);

export const Produce = () => (
  <section id="capabilities" data-testid="studio-capabilities" className="border-t border-white/10 bg-sink py-24 sm:py-32 lg:py-40">
    <div className="mx-auto max-w-[1480px] px-5 sm:px-8 lg:px-12">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Reveal><Eyebrow>What We Produce</Eyebrow></Reveal>
          <Reveal delay={0.05}><H2 className="mt-6">What Can We <span className="text-brand">Create?</span></H2></Reveal>
        </div>
        <Reveal delay={0.1} className="lg:col-span-4 lg:col-start-9">
          <p className="text-base leading-relaxed text-zinc-400 sm:text-lg">From one-off campaigns to ongoing content production, we create AI-powered video across a wide range of formats.</p>
        </Reveal>
      </div>
      <div className="mt-16 border-t border-white/10" data-testid="studio-produce-list">
        {PRODUCE.map(([t, d], i) => (
          <Reveal key={t} delay={(i % 4) * 0.04}>
            <div className="group grid gap-3 border-b border-white/10 py-7 transition-colors duration-500 hover:bg-coal sm:py-9 lg:grid-cols-12 lg:items-center lg:gap-8 lg:px-4">
              <span className="font-mono text-[11px] text-brand lg:col-span-1">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="font-display text-2xl font-bold text-white transition-transform duration-500 group-hover:translate-x-2 sm:text-3xl lg:col-span-5">{t}</h3>
              <p className="text-base leading-relaxed text-zinc-400 lg:col-span-6">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
